import { useEffect, useState } from "react";
import api from "../lib/api";

let _cache = null;

export function useCmsBlocks() {
  const [blocks, setBlocks] = useState(_cache || {});
  useEffect(() => {
    api.get("/cms/blocks").then(({ data }) => { _cache = data || {}; setBlocks(_cache); }).catch(() => {});
  }, []);
  return blocks;
}
